import { define, type, auto, Record, Collection } from 'type-r'
import { TypeWhenCollection } from './type_when'
import ValidRecord from './valid_record'
import PowerBool from '#metatypes/power_bool.js'

@define 
export class TypeIncidentInfo extends ValidRecord {
    @(type(PowerBool).as) confirmed: boolean
    @(type(TypeWhenCollection).value([]).as) history: TypeWhenCollection
}
